<template>
  <div
    v-if="computedIsShowTab"
    class="leave-tab fb fb-main-start fb-cross-center font-36"
    :class="{ 'tab-bottom': showBottom }"
  >
    <a
      class="item-flex-1"
      :class="{ active: type === LEAVE_SEARCH_TYPE.agentLeave }"
      @click="handlerToggleTab(LEAVE_SEARCH_TYPE.agentLeave)"
      >代请假</a
    >
    <a
      class="item-flex-1"
      :class="{ active: type === LEAVE_SEARCH_TYPE.allLeave }"
      @click="handlerToggleTab(LEAVE_SEARCH_TYPE.allLeave)"
      >全部请假</a
    >
  </div>
</template>

<script>
import { LEAVE_SEARCH_TYPE, LEAVE_ROLE } from '@/utils/constUtils'
import mixin from '@/mixin'
export default {
  name: 'commonTime',
  mixins: [mixin],
  components: {},
  props: {
    history: {
      type: Boolean,
      default: false
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    agentApplyCount: 0,
    defaultTabId: {
      type: Number,
      default: LEAVE_SEARCH_TYPE.agentLeave
    },
    role: Number
  },
  data() {
    return {
      LEAVE_SEARCH_TYPE: LEAVE_SEARCH_TYPE,
      type: LEAVE_SEARCH_TYPE.agentLeave
    }
  },
  computed: {
    computedIsShowTab() {
      switch (this.role) {
        case 100:
          return (
            this.isAdmin ||
            this.isHeadmaster ||
            this.isClassTeacher ||
            this.isCustomRole
          )

        default:
          return [
            LEAVE_ROLE.admin,
            LEAVE_ROLE.headmaster,
            LEAVE_ROLE.customRole
          ].includes(this.role)
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      this.type = this.defaultTabId
    },
    handlerToggleTab(type) {
      this.type = type
      this.$emit('change', type)
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.leave-tab {
  text-align: center;
  background: #ffffff;
  line-height: 48px;

  > a {
    display: inline-block;
    position: relative;
  }

  > a.active {
    color: #006afe;
  }

  > a.active:after {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    background-color: #006afe;
    width: 100%;
    height: 4px;
  }
}
.tab-bottom {
  border-bottom: 1px solid rgba(#191f25, 0.12);
}
</style>
